











import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { BTableHelpers } from '@/mixins/bTable';
import { EVENT_BUS, WorkflowJobHistoryDataModel } from '@/types';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { EventBus } from '@/classes/EventBus';

export default Vue.extend({
  name: 'MStoreDocumentHistoryTab',
  mixins: [BTableHelpers],
  props: {
    documentId: {
      type: Number,
      required: true
    },
    cabinetId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      workflowJobHistoryData: {} as WorkflowJobHistoryDataModel
    };
  },
  methods: {
    async getDocumentHistoryAsync(this: any, documentId: number, cabinetId: string) {
      this.isLoading = true;
      try {
        this.workflowJobHistoryData = await ApiConfiguration.apiWithErrorPage().documentTabs.documentTabsHistoryTabDetail(documentId, cabinetId);
      } finally {
        this.isLoading = false;
      }
    },
    async refreshDocumentHistoryAsync(this: any, documentId: number, cabinetId: string) {
      this.workflowJobHistoryData = await ApiConfiguration.apiWithErrorPage().documentTabs.documentTabsHistoryTabDetail(documentId, cabinetId);
    }
  },
  mounted() {
    this.getDocumentHistoryAsync(this.documentId, this.cabinetId);
    EventBus.$on(EVENT_BUS.DOCUMENT_HISTORY_LOG_UPDATED, () => this.refreshDocumentHistoryAsync(this.documentId, this.cabinetId));
  },
  beforeDestroy() {
    EventBus.$off(EVENT_BUS.DOCUMENT_HISTORY_LOG_UPDATED);
  },
  components: {
    LoadingSpinner
  }
});
